import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { ResponsiveService } from '../shared/responsive/responsive.service';
import { UtilService } from '../shared/services/util.service';
import { StatusCode, StatusColor, statusCodeValues, newPriceRecommenderObjective, scenerioType } from '../core/enum';
import * as constant from '../shared/constants/constants';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { MatSort } from '@angular/material/sort';
import { TableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { PriceRecommenderService } from '../shared/services/price-recommender.service';
import { UrlSecurityService } from '../shared/services/url-security.service';

@Component({
  selector: 'app-header-details-card',
  templateUrl: './header-details-card.component.html',
  styleUrls: ['./header-details-card.component.scss']
})
export class HeaderDetailsCardComponent implements OnChanges {

  /** Input Variable to get data from parent component */
  @Input('ScenarioInformationDetails') scenario_information_details: any;
  @Input('pt_settings') pt_settings: any;

  /**Orientation */
  TabletLandscape: boolean = false;
  TabletProtrait: boolean = false;
  smallScreen: boolean = false;

  /** Status enum Variables */
  status_text: any;
  status_color: any;
  status_id: any;
  approved_code: any;
  scenario_type: any = scenerioType;

  /**Table viewport calculation */
  view_port_height: number = constant.common.defaultTableHeight;
  view_port_height2: number = constant.common.defaultTableHeight; 
  @ViewChild(CdkVirtualScrollViewport) view_port: CdkVirtualScrollViewport;
  @ViewChild(CdkVirtualScrollViewport) view_port2: CdkVirtualScrollViewport;
  @ViewChild(CdkVirtualScrollViewport) view_port3: CdkVirtualScrollViewport;
  @ViewChild(MatSort) sort: MatSort;
  data_source = new TableVirtualScrollDataSource<any>([]);
  data_source2 = new TableVirtualScrollDataSource<any>([]);
  price_band_data_source :any = new TableVirtualScrollDataSource<any>([]);
  constraint_table_columns: any = [];
  item_details_table_columns: any = [];

  /** Objective enum variable */
  new_pr_objective: any = newPriceRecommenderObjective;
  objective_flag: boolean = false;

  /**popup table variables */
  item_size: number = constant.common.itemSize;
  item_size2: number = constant.common.itemSize;

  constructor(
    public responsiveService: ResponsiveService, 
    public utilService: UtilService,
    public urlService: UrlSecurityService,
    public priceRecommenderService: PriceRecommenderService
  ){}

  ngOnChanges() {
    this.screenOrientation();
    this.setInitialDTO();
    this.validateHeaderData();
  }

  /** Payload to Set/Reset Intial Data for Component */
  setInitialDTO() {
    this.status_text = StatusCode;
    this.status_color = StatusColor;
    this.approved_code = statusCodeValues.approved;
    this.constraint_table_columns = constant.price_recommender.constraint_pop_up_table_columns;
    this.item_details_table_columns = constant.price_recommender.item_details_pop_up_table_columns;
  }

  /** Validate if header data is not null and get status code */
  validateHeaderData() {
    if(!this.utilService.isNullOrEmptyOrUndefined(this.scenario_information_details)){
      this.status_id = this.scenario_information_details.status_id;
    }
  }

  /** To set the screen resolution */
  screenOrientation() {
    this.TabletLandscape = this.responsiveService.deviceTablet() && this.responsiveService.orientationLandscape();
    this.TabletProtrait = this.responsiveService.deviceTablet() && this.responsiveService.orientationPortrait();
    this.smallScreen = this.responsiveService.screenSize == 'Small';
  }

  /** Close Popup */
  closePopup() {
    this.objective_flag = false;
  }

  /**
   * calculation viewPort Height in px
   * @param count: length of data array
   */
  viewPortCalculation(count: number) {
    count = constant.common.zero ? this.view_port_height = count : this.view_port_height = this.utilService.viewPortCalcuation(count);
  }

  /** Open Objective popup */
  openObjectivePopUP() {
    this.objective_flag = true;
    this.data_source = new TableVirtualScrollDataSource(this.pt_settings.objective["constraints"]);
    let item_details: any = [];
    this.pt_settings.objective["item_details"].map((val: any) => {
      if(val.all_items == 1){
        item_details.push({
          product_category : val.skun02,
          items: 'All'
        })
      }
      else{
        val.sku01.map((val_items: any) => {
          item_details.push({
            product_category : val.skun02,
            items: val_items
          })
        })
      }
    });
    this.data_source2 = new TableVirtualScrollDataSource(item_details);
    this.price_band_data_source = this.pt_settings.price_band_config_data ? new TableVirtualScrollDataSource(this.pt_settings.price_band_config_data ) : new TableVirtualScrollDataSource([]);
  }
}
